module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    staticStyle: {
      "opacity": "0",
      "height": "0",
      "width": "0",
      "padding": "0"
    },
    attrs: {
      "type": "file",
      "multiple": _vm.multiple
    },
    on: {
      "change": _vm.onChange
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03d4b9a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UploadBase64.vue
// module id = 776
// module chunks = 1